<template>
  <div class="flex flex-col min-h-screen relative">
    <header
      class="flex border-b-corepla-dark border-b-8 shadow h-[75px] items-end text-corepla-text"
      :data-version="version"
    >
      <div class="flex-grow">
        <div class="py-2 px-2">
          <RouterLink
            class="flex items-center"
            to="/"
          >
            <img
              class="w-[70px]"
              src="https://assets.astecorepla.com/logo-corepla.png"
            >
            <div class="ml-4 font-bold">
              Aste Corepla Admin
            </div>
          </RouterLink>
        </div>
      </div>
      <div
        v-if="authStore.isAuthenticated"
        class="py-2 px-2"
      >
        <nav
          class="text-right flex items-center cursor-pointer"
          @click="userDropdown = true"
        >
          <span class="mr-2 text-xs">{{ authStore.user.nickname }}</span>
          <img
            class="h-[50px]"
            :src="authStore.user.picture"
          >
        </nav>
        <div
          v-if="userDropdown"
          v-on-click-outside="closeUserDropdown"
          class="absolute right-0 bg-white w-[200px] shadow text-black text-sm z-10"
        >
          <RouterLink
            v-if="authStore.isAdmin"
            class="block py-2 px-4 hover:bg-corepla-bg-light"
            to="/profilo"
            @click="closeUserDropdown"
          >
            Profilo
          </RouterLink>
          <a
            class="block py-2 px-4 hover:bg-corepla-bg-light"
            href="#"
            @click.prevent="logout"
          >Logout</a>
        </div>
      </div>
    </header>

    <div class="text-corepla-text flex-grow flex">
      <RouterView />
    </div>
    <div
      v-if="errorsStore.errors.length > 0"
      class="absolute top-0 right-0 h-full w-full bg-gray-500 bg-opacity-70"
    >
      <div
        class="absolute border shadow bg-white w-[400px] h-[200px] left-1/2 top-1/2 -ml-[200px] -mt-[100px] flex flex-col pb-2"
      >
        <div class="bg-corepla-dark p-2 text-white">
          <ExclamationTriangleIcon class="h-5 w-5 inline mr-2" />
          Si è verificato un errore
        </div>
        <div class="flex-grow">
          <div
            v-for="error, i in errorsStore.errors"
            :key="'global-error-' + i"
            class="p-2 text-red-400 font-bold"
          >
            {{ error.message }}
          </div>
        </div>
        <div class="text-right m-2">
          <a
            class="bg-gray-100 p-2"
            href="#"
            @click="closeErrorModal"
          >Chiudi</a>
        </div>
      </div>
    </div>

    <div
      v-if="versionStore.newVersionAvailable"
      class="absolute top-0 right-0 h-full w-full bg-gray-500 bg-opacity-70 z-20"
    >
      <div
        class="absolute border shadow bg-white w-[400px] left-1/2 top-1/2 -ml-[200px] -mt-[100px] flex flex-col pb-2"
      >
        <div class="bg-corepla-dark p-2 text-white">
          <ArrowPathIcon class="h-5 w-5 inline mr-2" />
          Nuova versione disponibile
        </div>
        <div class="flex-grow p-4">
          È disponibile una nuova versione dell'applicazione. Aggiornare ora?
        </div>
        <div class="text-right m-2">
          <a
            class="bg-corepla-dark text-white p-2"
            href="#"
            @click.prevent="versionStore.applyUpdate()"
          >Aggiorna</a>
        </div>
      </div>
    </div>

    <div
      v-if="notificationStore.notifications.length > 0"
      class="absolute bottom-10 right-10"
    >
      <div
        v-for="notification in notificationStore.notifications"
        :key="'notification-' + notification.id"
        class="rounded bg-green-600 text-white px-2 py-1 mb-2 shadow"
        :class="{ 'bg-green-600' : notification.type == 'success', 'bg-red-600' : notification.type == 'error'}"
      >
        {{ notification.message }}
        <XMarkIcon
          class="h-4 w-4 inline-block cursor-pointer"
          @click="notificationStore.removeNotification(notification.id)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useAuth0 } from '@auth0/auth0-vue';
import { ArrowPathIcon, ExclamationTriangleIcon, XMarkIcon } from '@heroicons/vue/24/outline'
import { vOnClickOutside } from '@vueuse/components'
import { ref } from 'vue';
import { RouterLink, RouterView } from 'vue-router'

import { useAuthStore } from './stores/auth';
import { useErrorsStore } from './stores/errors';
import { useNotificationsStore } from './stores/notifications';
import { useVersionStore } from './stores/version';

const authStore = useAuthStore()
const errorsStore = useErrorsStore();
const notificationStore = useNotificationsStore()
const versionStore = useVersionStore()

const { logout: auth0Logout } = useAuth0();

const logout = function () {
  auth0Logout({ returnTo: window.location.origin })
}

const closeUserDropdown = function () {
  userDropdown.value = false
}

const userDropdown = ref(false)

const closeErrorModal = function () {
  const hasFatal = errorsStore.errors.find((error) => error.fatal);
  if (hasFatal) {
    window.location.reload();
  } else {
    errorsStore.resetStore()
  }
}

const version = __APP_VERSION__
</script>